import React from "react";
import { Routes, Route } from "react-router-dom";
import About from "../pages/About";
import Terms from "../pages/Terms";
import Contact from "../pages/Contact";
import GetAuth from "../components/GetAuth";
import NotFound from "../pages/NotFound";
import HomePage from "../pages/Home";
import Loans from "../users/Loans"
import Services from "../pages/Services";
import FixedDeposit from "../pages/FixedDeposit";
import ForeignCurrency from "../pages/ForeignCurrency";
import PrivateWorldEliteCard from "../pages/PrivateWorldEliteCard";
import MultiCurrencySavings from "../pages/MultiCurrencySavings";

const NotUser = () => {
  return (
   <div className="not-user">
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about-us" element={<About />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/contact-us" element={<Contact />} />
        <Route path="/login" element={<GetAuth />} />
        <Route path="/loans" element={<Loans />} />
        <Route path="/services" element={<Services />} />
        <Route path="/services/fixed" element={<FixedDeposit />} />
        <Route path="/services/foreign" element={<ForeignCurrency />} />
        <Route path="/services/elite" element={<PrivateWorldEliteCard />} />
        <Route path="/services/savings" element={<MultiCurrencySavings />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
   </div>
  );
};

export default NotUser;
